var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11 10c.552 0 1 .448 1 1v17h17c.552 0 1 .448 1 1s-.448 1-1 1H11c-.552 0-1-.448-1-1V11c0-.552.448-1 1-1zm5 7c.552 0 1 .448 1 1v8c0 .552-.448 1-1 1s-1-.448-1-1v-8c0-.552.448-1 1-1zm5 4c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1s-1-.448-1-1v-4c0-.552.448-1 1-1zm5-6c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1s-1-.448-1-1V16c0-.552.448-1 1-1z",
    className: "invert-light"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-dashboard.ebf570b9bf7efb398fc2438f63f3e115.svg";